module.exports = __webpack_public_path__ + "dotted/dotted-cf60c430dc778e89759394446c5ba329.svg";